export const MAX_SUPPORT_GENERATE_ITEMS = 200;

export const TABLE_KEY_FIELDS = {
  VEHICLE: 'vehicleId',
  ORDER: 'itemId',
} as const;

export const DEFAULT_ORIGIN_ID = '04FF3627-8F0A-44F8-8EB1-03F44F9385F1';

export const DEFAULT_DESTINY_ID = 'E484A798-F9EE-4F4F-A788-C0ABE6DAEE4D';
